import { SVGProps } from 'react'

function UserSelfieThird(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.25 18.75v3a1.5 1.5 0 0 1-1.5 1.5h-3M18.75.75h3a1.5 1.5 0 0 1 1.5 1.5v3M.75 5.25v-3a1.5 1.5 0 0 1 1.5-1.5h3M5.25 23.25h-3a1.5 1.5 0 0 1-1.5-1.5v-3"
        stroke="#AA70FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M12 13.125a4.125 4.125 0 1 0 0-8.25 4.125 4.125 0 0 0 0 8.25Z"
        stroke="#AA70FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.365 19.125a6.751 6.751 0 0 0-12.73 0"
        stroke="#AA70FF"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

UserSelfieThird.defaultProps = { role: 'graphics-document' }

export default UserSelfieThird
